<template>
  <div class="wrapper">
    <div class="container">
      <Logo class="logo" />
      <h1 class="title">Вход в учетную запись Bytorg</h1>
      <p class="description">Сделки / Лиды с тендерных площадок Беларуси</p>
      <div class="btns">
        <Button variant="gradient" class="btn" @click="openLoginModal">
          Войти
        </Button>
        <Button variant="outline" class="btn" @click="openRegistrationModal">
          Зарегистрироваться
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/assets/icons/new-logo.svg";
import Button from "@/components/homePage/Button.vue";
import RegistrationModal from "@/components/homePage/RegistrationModal";
import {
  RegistrationModalProperties,
  LoginModalProperties,
} from "@/utils/modalsProperties";
import BitrixLoginModal from "@/components/bitrix/BitrixLoginModal.vue";
import { mapActions, mapGetters } from "vuex";
import { bitrixAppPath } from "@/router/bitrix/app";
import { loadBitrixScript } from "../../utils/loadBitrixScript";

export default {
  name: "BitrixInstall",
  components: { Logo, Button },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("bitrix", ["isBitrixLinked"]),
  },
  methods: {
    ...mapActions("bitrix", ["initBitrix"]),
    openRegistrationModal() {
      this.$modal.show(RegistrationModal, null, RegistrationModalProperties);
    },
    openLoginModal() {
      this.$modal.show(BitrixLoginModal, null, LoginModalProperties);
    },
  },
  watch: {
    isBitrixLinked(value) {
      if (value) {
        this.$router.push(bitrixAppPath);
      }
    },
  },
  async mounted() {
    try {
      await loadBitrixScript();
      this.initBitrix();
    } catch (e) {
      console.error("Ошибка загрузки API Битрикс24", e);
    }

    if (this.isAuthenticated) {
      this.$router.push(bitrixAppPath);
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: #484e55;
  .container {
    display: flex;
    flex-direction: column;
    max-width: 590px;
    gap: 20px;
    .logo {
      width: 126px;
      height: 60px;
    }
    .title {
      font-family: Montserrat;
      font-size: 48px;
      font-weight: 700;
      font-style: normal;
      color: #fff;
      margin: 0;
    }
    .description {
      font-family: Montserrat;
      font-size: 20px;
      font-weight: 500;
      font-style: normal;
      color: #fff;
    }
    .btns {
      display: flex;
      gap: 20px;
      .btn {
        width: 246px;
      }
    }
  }
}
</style>
